module.exports = __webpack_public_path__ + "img/tianyuanmeng_20210901112528.c2708f0a.png";